import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from './service';

interface PurchaseGiftcardProps {
  email: string;
  amount: number;
  payment: string;
  paymentIntentId?: string;
  paymentMethodId?: string;
  orderID?: string;
  senderName: string;
  recipientName: string;
  card?: string;
  invoice?: {
    businessName: string;
    addnress: string;
    vat?: string;
    ssn?: string;
    pec: string;
  };
}

export interface CMSSection {
  _id: string;
  title: string;
  description: string;
  appBackgroundImageUrl: string;
  icon_url: string;
  tag: string;
  enabled: boolean;
  category: string;
  rank: number;
}

export interface CMSSectionsResponse {
  winelivery: CMSSection[];
  campaigns: CMSSection[];
  partners: CMSSection[];
  stories: CMSSection[];
}

export default class UtilitiesService extends Service {
  /**
   * Acquista Giftcard
   */
  async purchaseGiftcard({
    email,
    amount,
    payment,
    paymentIntentId,
    paymentMethodId,
    orderID,
    senderName,
    recipientName,
    card,
    invoice,
  }: PurchaseGiftcardProps) {
    return await doRequest({
      auth: true,
      method: HttpMethodEnum.POST,
      url: `${this.root}v2/giftcards/`,
      body: {
        email,
        amount,
        payment,
        paymentIntentId,
        paymentMethodId,
        orderID,
        senderName,
        recipientName,
        invoice,
        card,
      },
    });
  }

  async emailSubscription(email: string, action: string) {
    return await doRequest({
      auth: false,
      method: HttpMethodEnum.POST,
      url: `${this.root}v1/email-subscription`,
      body: { email, action },
    });
  }
}
